import React from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import SaleVoucherRAForm from './SaleVoucherRAForm';

// Adapts the props-based form to react-router. The financial year is part of the voucher key and travels in the query string.
const SaleVoucherRAFormRoute = ({ mode }) => {
    const { voucherNo } = useParams();
    const [searchParams] = useSearchParams();
    const financialYear = searchParams.get('financialYear') || undefined;
    return <SaleVoucherRAForm key={`${mode}-${voucherNo || 'new'}-${financialYear || ''}`} mode={mode} voucherNo={voucherNo} financialYear={financialYear} />;
};

export default SaleVoucherRAFormRoute;
